import React from 'react';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import { PrivateRoute } from '../_components/PrivateRoute';
import { Welcome } from '../Frontend/Welcome/Welcome';
import { ProductList } from '../Frontend/Products/ProductList';
import { ProductPage }   from '../Frontend/Product-page/ProductPage';
import { ResetPassword } from "../Frontend/ResetPassword/index"
// import { Dashboard } from '../Backend/Dashboard/Dashboard';
import { Login } from '../Login/Login';
// import { Menu } from '../Backend/Menu/Menu';
// import { Products } from '../Backend/Products/Products';
// import { Branches } from '../Backend/Branch/Branch';
// import { Users } from '../Backend/Users/Users';
// import { Order } from '../Backend/Order/Order';
// import { Devices } from '../Backend/Devices/Devices';
// import { PostPages } from '../Backend/Posts/PostPages';
// import { PostNews } from '../Backend/Posts/PostNews';
// import { PostTestimonials } from '../Backend/Posts/PostTestimonials';
// import { PostArtists } from '../Backend/Posts/PostArtists';
// import { PostContents } from '../Backend/Posts/PostContents';
// import { PostCarousels } from '../Backend/Posts/PostCarousels';
// import { PostMarketing } from '../Backend/Posts/PostMarketing.js';
// import { Categories } from '../Backend/Categories/Categories';
// import { Settings } from '../Backend/Settings/Settings';

import PaynamicsResponseHandler from '../Frontend/Checkout/PaynamicsResponseHandler';

import { Page } from '../Frontend/Posts/Page';
import { New } from '../Frontend/News/New';
import { News } from '../Frontend/News/News';
import { About } from '../Frontend/Posts/About';
import { Content } from '../Frontend/Posts/Content';
import { Artists } from '../Frontend/Artists/Artists';
import { Artist } from '../Frontend/Artists/Artist';
// import { Payment } from '../Frontend/Payments/Payment';
import { UserProfileEdit } from '../Frontend/UserProfile/UserProfileEdit';
import { Cart }  from '../Frontend/MyCart/Cart';
import { Checkout }  from '../Frontend/Checkout/Checkout';
import { Contact }  from '../Frontend/Contact/Contact';
import  Stores  from '../Frontend/Stores/Store';
// import {SearchPage} from '../Frontend/Search/SearchPage';
import PageNotFound from '../_components/PageNotFound';
// import SocialMediaShareButtons from "../_components/SocialMediaShareButtons";
import './App.sass';

import loadable from "../loadable";

const Dashboard = loadable(() =>
  import("../Backend/Dashboard/Dashboard").then((module) => ({ default: module.Dashboard }))
);
const Menu = loadable(() =>
  import("../Backend/Menu/Menu").then((module) => ({ default: module.Menu }))
);
const Products = loadable(() =>
  import("../Backend/Products/Products").then((module) => ({
    default: module.Products,
  }))
);
const Branches = loadable(() =>
  import("../Backend/Branch/Branch").then((module) => ({
    default: module.Branches,
  }))
);
const Users = loadable(() =>
  import("../Backend/Users/Users").then((module) => ({ default: module.Users }))
);
const Order = loadable(() =>
  import("../Backend/Order/Order").then((module) => ({ default: module.Order }))
);
const Devices = loadable(() =>
  import("../Backend/Devices/Devices").then((module) => ({
    default: module.Devices,
  }))
);
const PostPages = loadable(() =>
  import("../Backend/Posts/PostPages").then((module) => ({
    default: module.PostPages,
  }))
);
const PostNews = loadable(() =>
  import("../Backend/Posts/PostNews").then((module) => ({
    default: module.PostNews,
  }))
);
const PostTestimonials = loadable(() =>
  import("../Backend/Posts/PostTestimonials").then((module) => ({
    default: module.PostTestimonials,
  }))
);
const PostArtists = loadable(() =>
  import("../Backend/Posts/PostArtists").then((module) => ({
    default: module.PostArtists,
  }))
);
const PostContents = loadable(() =>
  import("../Backend/Posts/PostContents").then((module) => ({
    default: module.PostContents,
  }))
);
const PostCarousels = loadable(() =>
  import("../Backend/Posts/PostCarousels").then((module) => ({
    default: module.PostCarousels,
  }))
);
const PostMarketing = loadable(() =>
  import("../Backend/Posts/PostMarketing").then((module) => ({
    default: module.PostMarketing,
  }))
);
const Categories = loadable(() =>
  import("../Backend/Categories/Categories").then((module) => ({
    default: module.Categories,
  }))
);
const Settings = loadable(() =>
  import("../Backend/Settings/Settings").then((module) => ({
    default: module.Settings,
  }))
);

class App extends React.Component {

    render() {
        return (
          <div className="App">
            <header className="App-header">
            <Router>
                <Switch>
                <Route exact path="/" component={Welcome} />\
                <Route exact path="/reset-password" component={ResetPassword} /> 
                <Route exact path="/login" component={Login} />
                <Route exact path="/page/*" component={Page} />
                <Route exact path="/news" component={New} />
                <Route exact path="/news/*" component={News} />
                <Route exact path="/About/*" component={About} />
                <Route exact path="/content/*" component={Content} />
                <Route exact path="/artists" component={Artists} />
                <Route exact path="/artist/*" component={Artist} />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/products" component={ProductList} />
                
                {/* Specific route for product details */}
                <Route exact path="/product/:slug" component={ProductPage} />
                
                <Route exact path="/cart" component={Cart} />
                <Route exact path="/stores" component={Stores} />
                <Route exact path="/checkout" component={Checkout} />
                <Route exact path="/user-profile" component={UserProfileEdit} />
                
                <PrivateRoute exact path="/admin/dashboard" component={Dashboard} />
                <PrivateRoute exact path="/admin/menu" component={Menu} />
                <PrivateRoute exact path="/admin/orders" component={Order} />
                <PrivateRoute exact path="/admin/products" component={Products} />
                <PrivateRoute exact path="/admin/branches" component={Branches} />
                <PrivateRoute exact path="/admin/devices" component={Devices} />
                <PrivateRoute exact path="/admin/users" component={Users} />
                <PrivateRoute exact path="/admin/pages" component={PostPages} />
                <PrivateRoute exact path="/admin/news" component={PostNews} />
                <PrivateRoute exact path="/admin/testimonials" component={PostTestimonials} />
                <PrivateRoute exact path="/admin/artists" component={PostArtists} />
                <PrivateRoute exact path="/admin/contents" component={PostContents} />
                <PrivateRoute exact path="/admin/carousels" component={PostCarousels} />
                <PrivateRoute exact path="/admin/marketing" component={PostMarketing} />
                <PrivateRoute exact path="/admin/categories" component={Categories} />
                <PrivateRoute exact path="/admin/settings" component={Settings} />

                <Route exat path="/paynamics-response/:orderId/:responseId" component={PaynamicsResponseHandler} />
                
                {/* Dynamic route for categories */}
                <Route exact path="/category/:slug" component={ProductList} />
                <Route exact path="/:slug" component={ProductList} />
                <Route exact path="/tags/:tag" component={ProductList} />
                
                {/* Catch-all route */}
                <Route path="*" component={PageNotFound} />
                </Switch>
            </Router>
            </header>
          </div>
        );
    }
}

export { App };